import React from 'react'
import './footer.css'
import { FaFacebookF } from 'react-icons/fa'
import { FiInstagram } from "react-icons/fi";
import { FaSnapchatGhost } from "react-icons/fa";

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>LORIK LOKU</a>

      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#school">School</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#certificates">Certificates</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://facebook.com"><FaFacebookF/></a>
        <a href="https://instagram.com"><FiInstagram/></a>
        <a href="https://snapchat.com"><FaSnapchatGhost/></a>
      </div>

      <div className="footer__copyright">
        <small>&copy; Made with ❤️ by Lorik Loku</small>
      </div>
    </footer>
  )
}

export default Footer